import { useCallback } from 'react';

import { useTrackAddonSubscriptionFunnel } from '../useTrackAddonSubscriptionFunnel/useTrackAddonSubscriptionFunnel';

import { useNavigate } from 'react-router';

import type { UseNavigateToAddonPageReturn } from '.';

/**
 * @deprecated once we update `@dashboard/library` to v2.36.0+ we should import this one from the library
 */
export function useNavigateToAddonPage(
  /**
   * Function to track events. We typically use track function from useDashboardExtensionContext
   * @example
   * ```ts
   * const { track } = useDashboardExtensionContext();
   * ```
   */
  track: (eventName: string, eventPayload: Record<string, unknown>) => void
): UseNavigateToAddonPageReturn {
  const navigate = useNavigate();

  const { trackAddonSubscriptionFunnelStarted } = useTrackAddonSubscriptionFunnel(track);

  const navigateToAddonsPage: UseNavigateToAddonPageReturn = useCallback(
    (addonName, buttonNameClicked) => {
      trackAddonSubscriptionFunnelStarted({ addonName, buttonNameClicked });
      navigate(`/addons/${addonName}`);
    },
    [navigate, trackAddonSubscriptionFunnelStarted]
  );

  return navigateToAddonsPage;
}
